import React from "react";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

/**
 * A transaction's date with its clock time underneath.
 *
 * The time is what distinguishes two journals booked on the same day, so a
 * date-only cell leaves the row order looking arbitrary even once the ordering
 * is correct. Showing it makes the sequence legible instead of merely right.
 *
 * Rows written before the form carried a time all read 00:00; that is the honest
 * value stored for them, so it is displayed rather than hidden.
 */
const DateTimeCell = ({ value, className = "" }) => {
  const { i18n } = useTranslation();

  const date = dayjs(value);
  if (!value || !date.isValid()) return <span className="text-gray-400">-</span>;

  const localized = date.locale(i18n.language);

  return (
    <div className={`text-sm text-gray-900 ${className}`}>
      {localized.format("DD MMM YYYY")}
      <div className="text-xs text-gray-500">{localized.format("HH:mm")}</div>
    </div>
  );
};

export default DateTimeCell;
